/** Year one, as Srini stated it on 2026-09-22. No customer names. */
export const FOUNDED = 'September 29, 2025';

export const PROOF = [
  { value: 5,   suffix: '',  label: 'Customers', note: 'in year one' },
  { value: 100, suffix: '+', label: 'Executives trained', note: 'through the AI Jumpstart for Executives at The Ohio State University' },
  { value: 150, suffix: '+', label: 'Compass completions', note: 'free, no account, ten minutes' },
  { value: 50,  suffix: '',  label: 'Innovative companies', note: 'Thinkers360 top 50, 2026', display: 'Top 50' },
  { value: 25,  suffix: '',  label: 'Founder on the AI25', note: 'Ohio Tech News and OhioX, 2026', display: 'AI25', href: 'https://www.ohiotechnews.com/ai25-2026-people-defining-ohios-ai-economy/' },
];

export const ORG_JSON_LD = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Right Brain Labs',
  url: 'https://www.rightbrainlabs.ai',
  logo: 'https://www.rightbrainlabs.ai/rbl-mark.svg',
  foundingDate: '2025-09-29',
  founder: { '@type': 'Person', name: 'Srini Koushik', url: 'https://www.srinikoushik.com' },
  address: { '@type': 'PostalAddress', addressLocality: 'New Albany', addressRegion: 'OH', addressCountry: 'US' },
  sameAs: ['https://www.linkedin.com/company/right-brain-labs-ai/', 'https://rightbrainedai.substack.com'],
  description: 'Right Brain Labs is an AI capability incubator.',
  slogan: 'The agency to think with AI, not follow it.',
};
